import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const taperCandleProducts = [
  {
    id: "nazareth-scented-madeleine",
    name: "NAZARETH SCENTED MADELEINE",
    subtitle: "6 столовых свечей",
    price: "2500 ₽",
    image1: "/images/ac/cr-1.png",
    image2: "/images/ac/cr-2.jpg",
  },
  {
    id: "fir-scented-madeleine",
    name: "FIR SCENTED MADELEINE",
    subtitle: "6 столовых свечей",
    price: "2500 ₽",
    image1: "/images/ac/di-1.png",
    image2: "/images/ac/di-2.jpg",
  },
  {
    id: "exotic-fuchsia",
    name: "Exotic Fuchsia",
    subtitle: "6 столовых свечей",
    price: "2500 ₽",
    image1: "/images/ac/ef-1.png",
    image2: "/images/ac/ef-2.png",
  },
  {
    id: "emerald-green",
    name: "Emerald Green",
    subtitle: "6 столовых свечей",
    price: "2500 ₽",
    image1: "/images/ac/eg-1.png",
    image2: "/images/ac/eg-2.png",
  },
  {
    id: "orchid-pink",
    name: "Orchid Pink",
    subtitle: "6 столовых свечей",
    price: "2500 ₽",
    image1: "/images/ac/op-1.png",
    image2: "/images/ac/op-2.png",
  },
  {
    id: "pure-white",
    name: "Pure White",
    subtitle: "6 столовых свечей",
    price: "2500 ₽",
    image1: "/images/ac/pw-1.png",
    image2: "/images/ac/pw-2.png",
  },
  {
    id: "sunny-yellow",
    name: "Sunny Yellow",
    subtitle: "6 столовых свечей",
    price: "2500 ₽",
    image1: "/images/ac/sy-1.png",
    image2: "/images/ac/sy-2.png",
  },
  {
    id: "desert-biege",
    name: "Desert Beige",
    subtitle: "6 столовых свечей",
    price: "2500 ₽",
    image1: "/images/ac/db-1.png",
    image2: "/images/ac/db-2.png",
  },
];

const TaperCandles = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <nav className="text-sm text-gray-500 mb-4">
        <Link to="/" className="hover:underline">Главная</Link> {' > '} <Link to="/products" className="hover:underline">Продукция</Link> {' > '} <span className="font-semibold">Столовые свечи</span>
      </nav>

      <div className="text-center mb-12 pt-16"> {/* Added pt-16 for spacing from menu */}
        <h2 className="font-cormorant-garamond text-2xl tracking-[0.3em] text-gray-600 mb-2 uppercase">Antique Collection</h2>
        <h1 className="font-cormorant-garamond text-5xl font-bold mb-4">СТОЛОВЫЕ СВЕЧИ</h1>
        <p className="text-gray-700 max-w-3xl mx-auto italic">
          Откройте для себя коллекцию столовых свечей Budnik Bee Garden. Каждая свеча, созданная вручную из 100% натурального пчелиного воска, дарит теплое, чистое горение и нежный медовый аромат. Идеально подходят для создания уютной атмосферы и особых моментов.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {taperCandleProducts.map((product) => (
          <div key={product.id} className="group relative flex flex-col items-center text-center">
            <div className="relative w-full overflow-hidden">
              <img
                src={product.image1}
                alt={product.name}
                className="w-full h-auto object-cover transition-opacity duration-300 group-hover:opacity-0"
              />
              <img
                src={product.image2}
                alt={`${product.name} hover`}
                className="w-full h-auto object-cover absolute top-0 left-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
              />
            </div>
            <h3 className="font-cormorant-garamond text-lg font-semibold mt-4">{product.name}</h3>
            <p className="text-black text-sm italic font-light">{product.subtitle}</p>
            <p className="text-gray-800 font-light mt-1">{product.price}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TaperCandles;